
import React from 'react';
import { useTranslation } from 'react-i18next';
import DividerWithText from "../../../../../components/DividerWithText";
import PhotoPickerSummary from "../../../../../components/PhotoPicker/PhotoPickerSummary";
import RowResumeText from "../../../../../components/RowResumeText";
import {EMPTY_VALUES, getDateFormat} from "../../../../../Apis/functions";
import {gender} from "../../../../../enums/genderEnum";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const SupplierSummary = (
    {
        user,
        photoPicker,
        getAllServiceType
    }
) => {

    const { t } = useTranslation();

    const SummaryContainer = ({ children }) => {
        return (
            <div className="d-flex justify-content-center align-content-center">
                <div className="content-center-w-600px">
                    {children}
                </div>
            </div>
        );
    }

    const item = getAllServiceType.find((item) => item.id === user?.serviceTypeId);
    return (
        <>

            <DividerWithText title={t('take_photography')} />
            <PhotoPickerSummary
                photoPicker={photoPicker}
                classWith={'content-center-w-400px'}
            />
            <DividerWithText title={t('company_details')} />
            <SummaryContainer>
                <div className="row">
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('acronym')} value={user?.acronym || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('company_name')} value={user?.supplierCompanyName || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('address')} value={user?.address || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('service_type')} value={item?.name || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 pb-2">
                        <RowResumeText title={t('description')} value={user?.description || EMPTY_VALUES.DEFAULT} />
                    </div>
                </div>
            </SummaryContainer>

            <DividerWithText title={t('manager_details')} />
            <SummaryContainer>
                <div className="row">
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('name')} value={user?.name || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('last_name')} value={user?.lastName || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('second_last_name')} value={user?.secondLastName || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('document_id')} value={user?.documentId || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('email')} value={user?.email || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('phone_number')} value={user?.phoneNumber || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('gender')} value={t(gender[user?.genderId]) || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className="col-12 col-sm-6 pb-2">
                        <RowResumeText title={t('dob')} value={getDateFormat(user?.dob, false)} />
                    </div>
                </div>
            </SummaryContainer>
        </>
    );

}

export default SupplierSummary
